import { HttpTransportType, HubConnection, HubConnectionBuilder } from '@microsoft/signalr'

const connections: { [key: string]: HubConnection } = {}

const createConnectionKey = (baseUrl: string, accessToken: string): string => {
  return `${baseUrl}_${accessToken}`
}

export const getConnection = (baseUrl: string, accessToken: string): HubConnection => {
  const key = createConnectionKey(baseUrl, accessToken)

  if (!connections[key]) {
    const connectionUrl = `${baseUrl}/panel-hub?access_token=${accessToken}`
    const connection: HubConnection = new HubConnectionBuilder()
      .withUrl(connectionUrl, {
        skipNegotiation: true,
        transport: HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .build()

    connections[key] = connection
  }

  return connections[key]
}

export const closeAndRemoveConnection = (baseUrl: string, accessToken: string) => {
  const key = createConnectionKey(baseUrl, accessToken)
  const connection = connections[key]
  if (connection) {
    connection
      .stop()
      .then(() => {
        delete connections[key]
      })
      .catch(() => {
        ///
      })
  }
}

export default getConnection
